import React from "react";
import { renderLayout } from "schema/ThemeSet.react";
import UploadButton from "slides/components/UploadButton.react";
import OptionButton from "slides/components/OptionButton.react";

export default class FileUploader extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            uploaded: false,
            thisFile: null,
        };
    }
    reset = () => {
        this.setState({ thisFile: null, uploaded: false });
    };
    handleSubmit = (file) => {
        this.setState({ thisFile: file, uploaded: true });
    };
    handleContinue = () => {
        this.props.trackInteraction(this.state.thisFile.base64);
    };

    render() {
        let isPortrait =
            this.props.mobileView || window.innerHeight > window.innerWidth;
        let LayoutRender = renderLayout(isPortrait, this.props.layout);
        return (
            <div className="full-height">
                <LayoutRender
                    {...this.props}
                    title={"Upload a file:"}
                    mainContent={
                        <div>
                            <UploadButton
                                {...this.props}
                                uploaded={this.state.uploaded}
                                onDone={this.handleSubmit}
                                reset={this.reset}
                            />
                            {this.state.uploaded && (
                                <OptionButton
                                    {...this.props}
                                    name="Continue"
                                    handleClick={this.handleContinue}
                                />
                            )}
                        </div>
                    }
                />
            </div>
        );
    }
}
